import {
  getContentCall,
  getFindAKFCContentData,
  getGuestContentData,
} from '@kfc-global/react-shared/redux/Actions/ContentAction';
import getContentFaqCall from '@kfc-global/react-shared/redux/Actions/FaqActions';
import getMarketConfigContentCall from '@kfc-global/react-shared/redux/Actions/MarketConfigAction';
import { getTendersContent } from '@kfc-global/react-shared/redux/Actions/PaymentsContentAction';
import { ChannelManager } from 'common/manager';
import { getCmsClient } from './cmsClient';
import getContentPlpDisclaimer from '@kfc-global/react-shared/redux/Actions/PLPDisclaimerAction';
import { contentfulActions } from '@kfc-global/react-shared/redux/Slices/ContentfulSlice';

export const getFaqContent = () =>
  getContentFaqCall({
    object: getCmsClient(),
    contentFull: {
      content_type: 'staticLandingPage',
      'fields.page': 'FAQ',
      include: '5',
    },
  });

export const getMarketConfigContent = tenantReducer =>
  getMarketConfigContentCall({
    object: getCmsClient(),
    contentFull: {
      content_type: 'marketConfig',
      'fields.location': tenantReducer?.country,
      'fields.channel': ChannelManager.channel,
      include: 5,
    },
  });

export const getContent = userParams =>
  getContentCall({
    object: getCmsClient(),
    contentFull: {
      content_type: 'landingPage',
      'fields.pageType': 'HomePage',
      'fields.channel': ChannelManager.channel,
      include: '5',
    },
    userParams,
  });

export const getTenders = () =>
  getTendersContent({
    object: getCmsClient(),
    contentFull: {
      content_type: 'tenders',
      include: 5,
      select: 'sys.id,fields',
    },
  });

export const getGuestContent = () =>
  getGuestContentData({
    contentful: getCmsClient(),
    query: {
      content_type: 'form',
      'fields.page': 'GuestCheckOut',
      'fields.channel': ChannelManager.channel,
      include: '5',
    },
  });

export const getFindAKFCContent = () =>
  getFindAKFCContentData({
    object: getCmsClient(),
    contentFull: {
      content_type: 'staticLandingPage',
      'fields.page': 'FindAKFC',
      include: '5',
    },
  });

export const getTimeSpecificAlertContent = () =>
  getContentPlpDisclaimer({
    object: getCmsClient(),
    contentFull: {
      content_type: 'supportContent',
      'fields.title': 'Alerts',
      include: '5',
    },
  });
export const getAddHopeThankYouContent = () =>
  contentfulActions.fetch({
    contentful: getCmsClient(),
    query: {
      content_type: 'supportContent',
      include: '5',
      'fields.title': 'addHopeThankYou',
    },
  });

export const getAddHopeContent = () =>
  contentfulActions.fetch({
    contentful: getCmsClient(),
    query: {
      content_type: 'staticLandingPage',
      'fields.page': 'addHope',
      include: '5',
    },
  });

export const getOrderSummaryContent = service =>
  contentfulActions.fetch({
    contentful: getCmsClient(),
    query: {
      content_type: 'supportContent',
      'fields.title': 'OrderTracking',
      include: '5',
      'fields.service': `${service}`,
    },
  });

export const getGiftCardContent = () =>
  contentfulActions.fetch({
    contentful: getCmsClient(),
    query: {
      content_type: 'staticLandingPage',
      'fields.title': 'GiftCard',
      include: '5',
    },
  });
